// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3ByFt","vLegacy":"SelectSecondary_vLegacy__iMUGw","error":"SelectSecondary_error__3qiH7","disabled":"SelectSecondary_disabled__fqteh"};